const DropdownItem = (props) => {
  return <a class='qa-topic-selector-item' href={props.href}>{props.title}</a>
}

export default DropdownItem
